<template>
  <div class="make-approval">
    <search-box ref="searchBox" v-slot="{form}">
      <el-button ref="searchBtn" type="primary" :loading="isLoading" @click="initData(form)">
        查询
      </el-button>
      <el-button type="default" @click="resetForm">
        重置
      </el-button>
    </search-box>

    <div v-loading="isLoading" class="tableBody table-container">
      <el-table :data="tableData" border style="width: 100%" tooltip-effect="light">
        <el-table-column prop="contractNum" label="办理" align="left" fixed="left" width="100">
          <template v-slot="{row}">
            <el-button type="text" @click="handleIdea(row)">
              办理
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="approvalNumber" label="申请单号" align="left" width="150" />
        <el-table-column prop="projectName" label="项目名称" align="left" fixed="left" width="200">
          <template v-slot="{row}">
            <el-button type="text" class="el-btn-text-left" @click="jumpProjectDetail(row)">
              {{ row.projectName }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="contractNum" label="合同编号" align="left" width="150" />
        <el-table-column prop="orderUnit" label="代理商名称" align="left" width="200" />
        <el-table-column prop="invoiceAmount" label="开票金额（含税）" align="right" header-align="left" width="150" />
        <el-table-column prop="revMethod" label="收入确认方式" align="left" width="150" />
        <el-table-column prop="revRule" label="收入确认规则" align="left" width="150" />
        <el-table-column prop="customerType" label="客户类型" align="left" width="150" />
        <el-table-column prop="contractType" label="订单分类" align="left" />
        <el-table-column prop="applicantName" label="申请人" align="left" />
        <el-table-column prop="applicationTime" label="申请时间" align="left" width="150" />
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-size.sync="page.pageSize"
          :current-page.sync="page.pageIndex"
          :total="page.total"
          layout="total, prev, pager, next, jumper"
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>

    <!-- 办理 -->
    <notice-dialog
      ref="ideaRef"
      :is-show="isIdeaShow"
      :is-approve="true"
      :form-data="formDetail"
      @down-file="downFile"
      @handle-submit="handleSubmit"
      @handle-cancel="handleCancel"
    />
    <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
  </div>
</template>

<script>
import searchBox from '../../openTicketManagmentOfcontractAsWhole/components/searchBox.vue';
// 办理弹窗
import noticeDialog from '@/components/noticeDialog';
import {
  getPageQueryAppliedInvoice,
  getProcessinfo,
  processApproval,
  attachmentGetToken
} from '@/API/index.js';
export default {
  components: {
    searchBox,
    noticeDialog
  },

  data () {
    return {
      isLoading: false,
      isIdeaShow: false,
      formDetail: {}, // 办理回显展示
      rowDetail: {}, // 当前Item数据
      tableData: [],
      token: '',
      downloadUrl: '',
      fileserveDownUrl: '',
      page: {
        pageSize: 10,
        pageIndex: 1,
        total: 0
      }
    };
  },

  mounted () {
    this.initData();
    this.initToken();
  },

  methods: {
    initData () {
      this.isLoading = true;
      const params = {
        approvalRole: 3, // 财务角色
        approved: false, // 待审批：false，已审批：true
        ...this.$refs.searchBox.searchForm,
        ...this.page
      };
      getPageQueryAppliedInvoice(params).then(res => {
        const { data, status } = res.data;
        if (status === '200') {
          this.tableData = data.list;
          this.page.total = data.total;
          this.isLoading = false;
        }
      }).catch((e) => {
        this.isLoading = false;
        console.log(e);
      });
    },

    // 审批
    handleSubmit (data) {
      const { formData, ideaText, idea } = data;
      if (!idea && !ideaText) { // 不同意 && 意见为空提示
        this.$message.error('不同意请填写审批意见');
        return;
      }
      const params = {
        approvalNumber: formData.approvalNumber,
        approvalContent: ideaText,
        agree: idea, // （0 不同意）（1 同意）
        approvalRole: 3
      };
      processApproval(params).then(res => {
        const { data } = res;
        if (data.status === '200') {
          this.$message.success('操作成功');
          this.initData();
        }
        this.isIdeaShow = false;
      });
    },

    // 办理
    handleIdea (row) {
      this.rowDetail = row;
      this.isIdeaShow = true;
      getProcessinfo({
        approvalNumber: row.approvalNumber,
        approval: true
      }).then(res => {
        const { data, status } = res.data;
        if (status === '200') {
          this.formDetail = data;
        }
      });
    },

    initToken () {
      attachmentGetToken().then((res) => {
        let json = res.data;
        console.log(res, 'res');
        if (json.status === '200') {
          this.token = json.data.token;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch((err) => {
        console.log(err);
      });
    },

    downFile (row) {
      this.fileserveDownUrl = this.downFileUrl + `/${row.fileToken}?Token=${this.token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },

    resetForm () {
      this.$refs.searchBox.resetForm();
      this.page.pageIndex = 1;
      this.initData();
    },

    // 只用给切换来清内容
    resetFormValue () {
      this.$refs.searchBox.resetForm();
      this.page.pageIndex = 1;
    },

    handerSizeChange () {
      this.page.pageIndex = 1;
      this.initData();
    },

    handerCurrentChange () {
      this.initData();
    },

    handleCancel () {
      this.isIdeaShow = false;
      this.formDetail = {};
    },

    // 项目详情
    jumpProjectDetail ({ contractType, contractNum, contractId, civilInternational }) {
      let route = {};
      if (['国际业务下单', '国际分销下单'].includes(contractType)) {
        route = { name: 'businessDetails', params: { contractNum }, query: { id: contractId, isShowInternationalService: civilInternational || '0' } };
      } else {
        route = { name: 'orderPersionContractInfo', params: { contractNum }, query: { id: contractId, isdisabled: true, transact: '3' } };
      }
      let routeUrl = this.$router.resolve(route);
      window.open(routeUrl.href, '_blank');
    }
  }
};
</script>

<style>
.footer-btn {
  text-align: right;
}
.table-container .el-button span {
  line-height: 20px;
}
</style>
